import { IResponseSaveFeedback } from "interfaces/feedbacks/feedbackInterfaces";

export function formatSaveFeedback(response: any): IResponseSaveFeedback {
    return {
      id: response.Feedback.Id,
      guid: response.Feedback.Guid
    };
  }